/* FootDrop search crest bridge - reuse the complete verified crest library everywhere in Search Studio. */
(()=>{'use strict';
if(window.__fdSearchCrestBridge)return;window.__fdSearchCrestBridge=true;
const cache=new Map();
function resolve(name){
  name=String(name||'').trim();if(!name)return null;if(cache.has(name))return cache.get(name);
  const api=window.FDClubCrests;if(!api?.decorate){cache.set(name,null);return null;}
  const probe=document.createElement('span');probe.textContent=name;
  try{api.decorate(probe);}catch(_){cache.set(name,null);return null;}
  const img=probe.querySelector(':scope > .fd-title-crest');const url=img?.src||null;cache.set(name,url);return url;
}
function image(url){const img=document.createElement('img');img.alt='';img.loading='lazy';img.decoding='async';img.src=url;return img;}
function patchV3(card){
  const name=card.querySelector('.fdv3-team-copy strong')?.textContent?.trim();const media=card.querySelector('.fdv3-media');if(!name||!media)return;
  const url=resolve(name);if(!url||media.dataset.fdFullCrest===url)return;
  media.dataset.fdFullCrest=url;media.classList.remove('is-generic');media.replaceChildren(image(url));
}
function patchBase(link){
  const art=link.querySelector('.fdis-team-art');if(!art)return;
  const label=[...link.children].find(node=>node!==art)?.textContent?.trim();if(!label)return;
  const url=resolve(label);if(!url||art.dataset.fdFullCrest===url)return;
  art.dataset.fdFullCrest=url;art.classList.remove('fdcl-generic');const wrap=document.createElement('span');wrap.className='fdcl-plain';wrap.append(image(url));art.replaceChildren(wrap);
}
function patchCleanup(card){
  const name=card.querySelector('strong')?.textContent?.trim();const media=card.querySelector('.fdcl-pic');if(!name||!media)return;
  const url=resolve(name);if(!url||media.dataset.fdFullCrest===url)return;
  media.dataset.fdFullCrest=url;media.classList.remove('is-generic');media.replaceChildren(image(url));
}
function scan(root=document){
  if(root.matches?.('.fdv3-team'))patchV3(root);root.querySelectorAll?.('.fdv3-team').forEach(patchV3);
  if(root.matches?.('.fdis-team-link'))patchBase(root);root.querySelectorAll?.('.fdis-team-link').forEach(patchBase);
  if(root.matches?.('.fdcl-club'))patchCleanup(root);root.querySelectorAll?.('.fdcl-club').forEach(patchCleanup);
}
function start(){
  scan();let frame=0;const pending=new Set();
  new MutationObserver(records=>{for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1)pending.add(node);if(pending.size&&!frame)frame=requestAnimationFrame(()=>{frame=0;for(const node of pending)if(node.isConnected)scan(node);pending.clear();});}).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('fd:directory-ready',()=>scan());document.addEventListener('shopify:section:load',event=>scan(event.target));
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
